import * as React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { default as useResizeAware } from 'react-resize-aware';
import clsx from 'clsx';
import 'mapbox-gl/dist/mapbox-gl.css';
import { Map as MBMap } from 'mapbox-gl';
const useStyles = makeStyles(() => createStyles({
    resizeCont: {
        position: 'relative',
        display: 'flex',
        overflowY: 'hidden',
        overflowX: 'hidden',
    },
    mapStyle: {
        width: '100%',
        flexGrow: 1,
        overflow: 'hidden',
    },
}));
// ResizeListener is a separate component
// to avoid unnecessary renders of parent map
const ResizeListener = (props) => {
    const { map } = props;
    const [resizeListener, sizes] = useResizeAware();
    React.useEffect(() => {
        if (!map)
            return;
        map.resize();
    }, [map, sizes.width, sizes.height]);
    return React.createElement(React.Fragment, null, resizeListener);
};
const useMap = (containerClassName, options) => {
    const classes = useStyles();
    const [map, setMap] = React.useState();
    const opts = options !== null && options !== void 0 ? options : {
        accessToken: '',
        container: 'map',
        zoom: 15,
        center: [23.7278, 61.4951],
        dbName: 'mapboxIDB',
        dbStore: 'tiles',
        attributionControl: false,
    };
    React.useEffect(() => {
        setMap(new MBMap(opts));
    }, []);
    const container = (React.createElement("div", { className: clsx(containerClassName, classes.resizeCont) },
        React.createElement(ResizeListener, { map: map }),
        React.createElement("div", { id: 'map', className: classes.mapStyle })));
    return { map, mapContainer: container };
};
export default useMap;
